/* Sinneszauber \u2013 Lieferbarkeit laut Chogan-Bestand
   Liest chogan-bestand.json ({ stand, varianten: { "<Varianten-ID>": 1 | 0 } }), erstellt mit bestand.py.
   Produktseite: "Auf Lager" / "Derzeit nicht lieferbar" je gew\u00e4hlter Gr\u00f6\u00dfe, Warenkorb-Button gesperrt.
   Produktkarten: nicht lieferbare Gr\u00f6\u00dfen ausgegraut. Fehlt die Datei oder eine Variante, wird nichts angezeigt. */
(function () {
  const url = (window.SZ && SZ.bestandUrl) || '';
  let map = null;

  const status = (id) => {
    if (!map || id == null || id === '') return undefined;
    const v = map[String(id)];
    return v === undefined ? undefined : v === 1 || v === true;
  };

  function badge(ok) {
    return ok
      ? '<span class="sz-stock is-in"><i aria-hidden="true"></i>Auf Lager</span>'
      : '<span class="sz-stock is-out"><i aria-hidden="true"></i>Derzeit nicht lieferbar</span>';
  }

  // Produktseite (Theme: form[data-product-form], Vorschau: #pvForm)
  function applyProduct(root) {
    root.querySelectorAll('form[data-product-form], form#pvForm').forEach((form) => {
      const btn = form.querySelector('[data-add], button[type=submit]');
      const pick = () => (form.querySelector('[name=id]:checked') || form.querySelector('[name=id]') || {}).value;
      form.querySelectorAll('.pills input[name=id]').forEach((r) => {
        const s = status(r.value);
        r.closest('label') && r.closest('label').classList.toggle('is-out', s === false);
      });
      const update = () => {
        const s = status(pick());
        let el = form.parentElement.querySelector('.sz-stock-wrap');
        if (!el) {
          el = document.createElement('div');
          el.className = 'sz-stock-wrap';
          form.insertAdjacentElement('beforebegin', el);
        }
        const html = s === undefined ? '' : badge(s);
        if (el.innerHTML !== html) el.innerHTML = html;
        if (btn && s !== undefined) {
          if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
          btn.disabled = s === false;
          const txt = s === false ? 'Derzeit nicht lieferbar' : btn.dataset.label;
          if (btn.textContent !== txt) btn.textContent = txt;
        }
      };
      if (!form.dataset.szStock) {
        form.dataset.szStock = '1';
        form.addEventListener('change', (e) => { if (e.target.name === 'id') setTimeout(update, 0); });
      }
      update();
    });
  }

  // Produktkarten mit Gr\u00f6\u00dfenwahl (Duft-Mixer, Saisonseite, \u00e4hnliche D\u00fcfte)
  function applyCards(root) {
    root.querySelectorAll('.mx-card').forEach((card) => {
      card.querySelectorAll('.mx-sz[data-v]').forEach((chip) => chip.classList.toggle('is-out', status(chip.dataset.v) === false));
      const btn = card.querySelector('.mx-add');
      if (!btn) return;
      const s = status(btn.dataset.variant);
      if (s === undefined) return;
      if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
      btn.disabled = s === false;
      const txt = s === false ? 'Nicht lieferbar' : btn.dataset.label;
      if (btn.textContent !== txt) btn.textContent = txt;
    });
  }

  // Normale Produktkarten (Kollektionen, Specials, Neuheiten): direkter Warenkorb-Knopf bei Einzelartikeln
  function applyQuick(root) {
    root.querySelectorAll('.card [data-quick-add], .card [data-add-variant]').forEach((btn) => {
      const s = status(btn.getAttribute('data-quick-add') || btn.getAttribute('data-add-variant'));
      if (s === undefined) return;
      if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
      btn.disabled = s === false;
      const txt = s === false ? 'Derzeit nicht lieferbar' : btn.dataset.label;
      if (btn.textContent !== txt) btn.textContent = txt;
      const card = btn.closest('.card');
      if (card) card.classList.toggle('is-out', s === false);
    });
  }

  function apply(root) {
    if (!map) return;
    root = root || document;
    applyProduct(root);
    applyCards(root);
    applyQuick(root);
  }

  let live = false, watching = false;
  function start(m) {
    map = Object.assign({}, map || {}, m);
    apply(document);
    if (watching) return;
    watching = true;
    // neu gerenderte Karten/Seiten (Mixer, Vorschau-Seitenwechsel) nachziehen
    let t = 0;
    new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => apply(document), 60); })
      .observe(document.body, { childList: true, subtree: true });
    // Gr\u00f6\u00dfenwechsel auf Karten: Button-Status nachziehen
    document.addEventListener('click', (e) => { if (e.target.closest('.mx-sz')) setTimeout(() => applyCards(document), 0); });
  }
  // Bestand direkt aus Shopify (live.js, 15.10.2026) hat Vorrang vor bestand.json
  function setLive(m) { live = true; map = null; start(m); }

  if (url) {
    fetch(url, { cache: 'no-cache' })
      // Lokale Antworten des iOS-URLSchemeHandlers haben keinen normalen HTTP-Status.
      .then((r) => r.json())
      .then((d) => { if (d && d.varianten && !live) start(d.varianten); })
      .catch(() => {});
  }

  window.SZBestand = { status, apply, setLive };
})();
